import { useEffect, useState } from 'react';

/**
 * Device class hook. Warm Paper ED ships TWO distinct experiences that
 * share the same data + component layer:
 *   - mobile  → stack-navigated, bottom-tab app (the staff phone UX)
 *   - desktop → top-nav, multi-column web console (instructor/admin UX)
 *
 * Screens pick their variant from this hook rather than CSS reflow, so the
 * two UXs can diverge freely. The breakpoint matches Tailwind's `md`.
 */
const DESKTOP_QUERY = '(min-width: 900px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.matchMedia(DESKTOP_QUERY).matches : true,
  );

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
